import React from "react";
import "./ImagesCarousel.scss";
import { Carousel, Col, Image, Row } from "antd";
import Helpers from "@utils/Helpers";

const ImagesCarousel: React.FC<any> = ({ imageList }) => {
  return (
    <div className="ImagesCarousel">
      <Carousel autoplay>
        <Row className="d-inline-flex" gutter={[14, 14]}>
          {imageList?.map((item: string, index: number) => {
            return (
              <Col span={4} key={index}>
                <Image src={item} className="carousel-img" height={200} />
              </Col>
            );
          })}
        </Row>
        <Row className="d-inline-flex" gutter={[14, 14]}>
          {imageList?.map((item: string, index: number) => {
            return (
              <Col span={4} key={index}>
                <Image src={item} className="carousel-img" height={200} />
              </Col>
            );
          })}
        </Row>
      </Carousel>
    </div>
  );
};

export default ImagesCarousel;
